// extracted by mini-css-extract-plugin
module.exports = {"informer":"informer_informer__t69ra","informerBlock":"informer_informerBlock__q13e9"};